import React, { ReactElement } from 'react';
import { FdrImage } from '@hotelplan/supergraph-api';
import {
  FdrBlogArticleSection,
  FdrEmployeeDisrupter,
} from 'components/domain/fdr-blog-article';
import { FdrBlogOverviewInfoSection } from 'components/domain/fdr-blog-overview';
import { FdrHeroSection } from 'components/domain/fdr-hero-section';
import { FdrPageComponents } from 'components/domain/fdr-page-components';
import { fdrBlogArticlePageVars } from 'components/page/blog-article/blog-article.vars';
import { useFdrBlogArticlePageQuery } from 'schemas/query/blog-article/fdr-blog-article-page.generated';

export { getServerSideProps } from 'components/page/blog-article/blog-article.gssp';

interface IBlogArticleProps {
  id: string;
}

export default function BlogArticle({ id }: IBlogArticleProps): ReactElement {
  const queryResult = useFdrBlogArticlePageQuery({
    variables: {
      id,
      ...fdrBlogArticlePageVars,
    },
  });

  const { hero, title, text, flagline, employee, start, pageComponents } =
    queryResult?.data?.fdrBlogArticle || {};

  const dateString = new Date(start).toLocaleDateString(`de-DE`, {
    month: '2-digit',
    year: 'numeric',
    day: '2-digit',
  });

  return (
    <>
      {hero ? (
        <FdrHeroSection title={title} text={flagline} hero={hero as FdrImage}>
          <FdrEmployeeDisrupter
            image={employee?.image as FdrImage}
            name={employee?.name}
            date={dateString}
          />
        </FdrHeroSection>
      ) : null}
      <FdrBlogArticleSection>
        <FdrBlogOverviewInfoSection leadText={text} />
      </FdrBlogArticleSection>
      <FdrPageComponents components={pageComponents?.components} />
    </>
  );
}
